<app-collapsible-section
  title="Offer Overview"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onOfferOverviewToggle($event)"
  (done)="onOfferOverviewDone()"
>
  <ng-template #sectionContent>
    <div class="form-container">
      <div class="form-group-row">
        <div class="form-group">
          <label for="offerName">Offer Name<span class="required">*</span></label>
          <input
            type="text"
            id="offerName"
            [(ngModel)]="offerName"
            (ngModelChange)="onFormChange('offerName')"
            (focus)="onFieldFocus('offerName')"
            (blur)="onFieldBlur('offerName')"
            placeholder="e.g Black Friday Discount"
            maxlength="100"
            [class]="'form-control' + (hasError('offerName') ? ' error' : '')"
          />
          <div class="error-message" *ngIf="hasError('offerName')">
            {{ validationErrors.offerName }}
          </div>
        </div>
        <div class="form-group">
          <label for="promoCode">Promo Code<span class="required">*</span></label>
          <input
            type="text"
            id="promoCode"
            [(ngModel)]="promoCode"
            (ngModelChange)="onFormChange('promoCode')"
            (focus)="onFieldFocus('promoCode')"
            (blur)="onFieldBlur('promoCode')"
            placeholder="e.g. BF40"
            maxlength="100"
            [class]="'form-control' + (hasError('promoCode') ? ' error' : '')"
          />
          <div class="error-message" *ngIf="hasError('promoCode')">
            {{ validationErrors.promoCode }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="offerDescription">Offer Description<span class="required">*</span></label>
        <input
          type="text"
          id="offerDescription"
          [(ngModel)]="offerDescription"
          (ngModelChange)="onFormChange('offerDescription')"
          (focus)="onFieldFocus('offerDescription')"
          (blur)="onFieldBlur('offerDescription')"
          placeholder="e.g. Discount for 40% on Black Friday."
          maxlength="300"
          [class]="'form-control' + (hasError('offerDescription') ? ' error' : '')"
        />
        <div class="error-message" *ngIf="hasError('offerDescription')">
          {{ validationErrors.offerDescription }}
        </div>
      </div>
      <div class="form-footer">
        <button
          class="btn btn-primary btn-medium"
          type="button"
          (click)="onOfferOverviewDone()"
          [disabled]="isSaving"
        >
          <svg
            *ngIf="isSaving"
            class="done-spinner"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="8"
              cy="8"
              r="6"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-dasharray="31.416"
              stroke-dashoffset="8"
            />
          </svg>
          <span>{{ isSaving ? 'Saving...' : 'Done' }}</span>
        </button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>
